export const widgetGuideUrl = "https://widget.intelligence.weforum.org/index.html";
